module.exports = __webpack_public_path__ + "static/img/sl.b509cb60.jpg";